import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ILocation } from '../../../../api/locations';
import { IAppState, Dispatch } from '../../../../common/state';
import { EMetroTravelType } from '../../../../json_query';
import { openDirectionsModal } from '../../../state/directions';
import { openDistrictSwitcher } from '../../../state/districts/popup';
import { changeFromOffRep } from '../../../state/from_offrep';
import { changeIsByHomeowner } from '../../../state/is_by_homeowner';
import { changeIsDealRent } from '../../../state/is_deal_rent';
import { changeIsFromDeveloper } from '../../../state/is_from_developer';
import { openMetroModal } from '../../../state/metro/toggle_modal';
import { setMaxPrice, setMinPrice } from '../../../state/price';
import { checkExperiment } from '../../../../utils/isAbExperiment';
import { TagsContainer } from '../../tags/container';

import { MainFilters as MainFiltersComponent } from './mainFilters';
import { setMaxWorkPlaceCount, setMinWorkPlaceCount } from '../../../state/workplace_count';

const availableMetroScheme: number[] = require('@cian/metro/ready');

export interface IMainFiltersOwnProps {
  isAdvancedFiltersOpened?: boolean;
  onSearchButtonClick(): void;
}

export const mapStateToProps = (state: IAppState) => {
  const {
    filters: { backup, currentLocation, jsonQueryCount },
    isFetching,
    isCommercialOwnerFilterAvailable,
  } = state;

  const jsonQuery = (backup && backup.jsonQuery) || state.filters.jsonQuery;
  const tags = (backup && backup.tags) || state.filters.tags;

  const hasDistricts = currentLocation === 'moscow_mo' || currentLocation === 'spb_lo' || currentLocation.hasDistricts;

  const hasMetro = checkMetroSchemeAvailability(currentLocation);

  const tagsAvailable =
    tags.length > 0 ||
    (jsonQuery.only_foot && jsonQuery.only_foot.value !== EMetroTravelType.Any) ||
    (jsonQuery.foot_min && jsonQuery.foot_min.value.lte);

  return {
    backup,
    currentLocation,
    jsonQuery,
    jsonQueryCount,
    hasMetro,
    isFetching,
    isFromDeveloperExperiment: checkExperiment(state.experiments, 'newbuilding-serp-from-developer'),
    maxPrice: jsonQuery.price && jsonQuery.price.value.lte,
    maxWorkPlaceCount: jsonQuery.workplace_count && jsonQuery.workplace_count.value.lte,
    minPrice: jsonQuery.price && jsonQuery.price.value.gte,
    minWorkPlaceCount: jsonQuery.workplace_count && jsonQuery.workplace_count.value.gte,
    isLocationHasDistricts: hasDistricts,
    tags: tagsAvailable ? (TagsContainer as React.ComponentType) : null,
    withPhoto: Boolean(jsonQuery.wp && jsonQuery.wp.value),
    isCommercialOwnerFilterAvailable,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onIsByHomeownerChanged: changeIsByHomeowner,
      onIsDealRentChanged: changeIsDealRent,
      onIsFromDeveloperChanged: changeIsFromDeveloper,
      onFromOffRepChanged: changeFromOffRep,
      onMinPriceChanged: setMinPrice,
      onMaxPriceChanged: setMaxPrice,
      onMetroOpenButtonClick: openMetroModal,
      onDistrictClick: openDistrictSwitcher,
      onMinWorkPlaceCountChanged: setMinWorkPlaceCount,
      onMaxWorkPlaceCountChanged: setMaxWorkPlaceCount,
      openDirectionsModal,
    },
    dispatch,
  );

export const MainFilters = connect(mapStateToProps, mapDispatchToProps)(MainFiltersComponent);

function checkMetroSchemeAvailability(location: ILocation | 'moscow_mo' | 'spb_lo') {
  return !!(location === 'moscow_mo' || location === 'spb_lo' || availableMetroScheme.some(id => id === location.id));
}
